"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../../../CTAs/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InputFieldButton = function InputFieldButton(_ref) {
  var altInputRef = _ref.altInputRef,
      buttonAriaLabel = _ref.buttonAriaLabel,
      buttonOnClick = _ref.buttonOnClick,
      buttonText = _ref.buttonText,
      hidePasswordButtonAriaLabel = _ref.hidePasswordButtonAriaLabel,
      hidePasswordButtonText = _ref.hidePasswordButtonText,
      inputFieldButtonRef = _ref.inputFieldButtonRef,
      inputFieldButtonWrapperRef = _ref.inputFieldButtonWrapperRef,
      inputFieldButtonTestId = _ref.inputFieldButtonTestId,
      isPassword = _ref.isPassword,
      showPassword = _ref.showPassword,
      showPasswordButtonAriaLabel = _ref.showPasswordButtonAriaLabel,
      showPasswordButtonText = _ref.showPasswordButtonText,
      togglePasswordVisibility = _ref.togglePasswordVisibility;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      buttonWasToggled = _useState2[0],
      setButtonWasToggled = _useState2[1];

  var inputFieldButtonOnClick = function inputFieldButtonOnClick() {
    if (isPassword) {
      return function () {
        togglePasswordVisibility(!showPassword);
        setButtonWasToggled(buttonWasToggled + 1);
      };
    }

    return buttonOnClick;
  };

  var inputFieldButtonAriaLabel = function inputFieldButtonAriaLabel() {
    if (isPassword) {
      return showPassword ? hidePasswordButtonAriaLabel : showPasswordButtonAriaLabel;
    }

    return buttonAriaLabel;
  };

  var inputFieldButtonText = function inputFieldButtonText() {
    if (isPassword) {
      return showPassword ? hidePasswordButtonText : showPasswordButtonText;
    }

    return buttonText;
  };

  (0, _react.useEffect)(function () {
    if (buttonWasToggled > 0 && altInputRef.current) {
      altInputRef.current.focus();
    }
  }, [buttonWasToggled]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control__input-cta-wrapper",
    ref: inputFieldButtonWrapperRef
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text-secondary",
    size: "small",
    type: "button",
    text: inputFieldButtonText(),
    clickMethod: inputFieldButtonOnClick(),
    ariaLabel: inputFieldButtonAriaLabel(),
    ref: inputFieldButtonRef,
    dataTestId: inputFieldButtonTestId
  }));
}; // needed for prop type checking refs in server side rendered apps


var Element = typeof Element === 'undefined' ? function () {} : Element; // eslint-disable-line

InputFieldButton.propTypes = {
  /**
   Required. Ref for the input used to set focus on click.
   */
  altInputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })]).isRequired,

  /**
    Optional. Hidden text for the button in the input label for screen readers.
    */
  buttonAriaLabel: _propTypes.default.string,

  /**
   Required. The function passed to the click method of the button.
   */
  buttonOnClick: _propTypes.default.func,

  /**
   Optional. Visual text for the button in the input label.
   */
  buttonText: _propTypes.default.string,

  /**
    Optional. Hidden text for the "hide" button in the password input label for screen readers.
    */
  hidePasswordButtonAriaLabel: _propTypes.default.string,

  /**
   Optional. Visual text for the "hide" button in the password input label.
   */
  hidePasswordButtonText: _propTypes.default.string,

  /**
   Optional. ref to be passed down to root element.
   */
  inputFieldButtonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })]),

  /**
   Optional. ref to be passed down to root element.
   */
  inputFieldButtonWrapperRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })]),

  /**
   Optional. test id to be used in unit tests.
   */
  inputFieldButtonTestId: _propTypes.default.string,

  /**
   Optional. Defaults false.
   */
  isPassword: _propTypes.default.bool,

  /**
   Optional. Defaults false.
   */
  showPassword: _propTypes.default.bool,

  /**
   Optional. Hidden text for the "show" button in the password input label for screen readers.
   */
  showPasswordButtonAriaLabel: _propTypes.default.string,

  /**
   Optional. Visual text for the "show" button in the password input label.
   */
  showPasswordButtonText: _propTypes.default.string,

  /**
   Optional. Function to be passed to the label to toggle the password visibility.
   */
  togglePasswordVisibility: _propTypes.default.func
};
InputFieldButton.defaultProps = {
  buttonAriaLabel: '',
  buttonOnClick: function buttonOnClick() {},
  buttonText: '',
  hidePasswordButtonAriaLabel: 'Hide Password',
  hidePasswordButtonText: 'Hide',
  inputFieldButtonRef: null,
  inputFieldButtonWrapperRef: null,
  inputFieldButtonTestId: '',
  isPassword: false,
  showPassword: false,
  showPasswordButtonAriaLabel: 'Show Password',
  showPasswordButtonText: 'Show',
  togglePasswordVisibility: function togglePasswordVisibility() {}
};
var _default = InputFieldButton;
exports.default = _default;